import React from 'react'

const LogbooksSetting = () => {
    return (
        <div>LogbooksSetting</div>
    )
}

export default LogbooksSetting